import axios from "axios";
import { saveAs } from "file-saver";
import { getLocalStorageItem } from "../Utils";

const ExportButton = ({
  endpoint,
  fileName = "report.xlsx",
  pageSize,
  currentPage,
  extraPayload = {},
  label = "Export",
  className = "",
}) => {
  const handleExport = async () => {
    try {
      const formdata = new FormData();
      formdata.append("is_export", 1);
      //   formdata.append("per_page", pageSize);
      formdata.append("page_no", currentPage);

      // append extra params if needed
      Object.entries(extraPayload).forEach(([key, value]) => {
        formdata.append(key, value);
      });

      const res = await axios.post(endpoint, formdata, {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${getLocalStorageItem("access_token")}`,
        },
      });

      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(blob, fileName);
    } catch (err) {
      console.error("Export failed:", err);
    }
  };

  return (
    <p
      onClick={handleExport}
      className={`font-medium text-xs cursor-pointer bg-bsgreen hover:bg-green-600 text-white px-2 py-1 rounded-md text-[15px] mb-2 ${className}`}
    >
      {label}
    </p>
  );
};

export default ExportButton;
